/*
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-11 14:33:43
 * @LastEditTime: 2023-05-06 18:05:58
 * @Description:
 * @FilePath: \tudouec\src\main.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import '@/assets/css/public.scss'
import 'element-ui/lib/theme-chalk/index.css'
import LoadMore from './components/LoadMore.vue'
import Topic from './components/Topic.vue'
import SubMenu from './components/SubMenu.vue'
import api from './assets/js/api'
import { anchorTo } from './assets/js/utils'


Vue.config.productionTip = false
Vue.prototype.$api = new api()
Vue.prototype.$anchorTo = anchorTo
Vue.use(ElementUI)
Vue.component("LoadMore", LoadMore)
Vue.component("Topic", Topic)
Vue.component("SubMenu", SubMenu)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js